import { useSelector } from 'react-redux'

import { Duration as DurationField, useValidateOnChange } from 'components/event_type_edit'
import { isAvailableFeatureSelector } from 'features/billing'
import { useEventType } from 'features/event_type_provider'

import { useErrorAfterInitialTouch } from '../../hooks'

export const Duration = ({ isLocked, isReadOnly }) => {
  const eventType = useEventType()
  const { isMETChild, isMETParent } = eventType
  const isMultipleDurationsAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'multiple_durations' }))

  const showMultipleDurations = isMultipleDurationsAvailable && !isMETChild && !isMETParent

  useValidateOnChange('customEventDuration')
  useErrorAfterInitialTouch('customEventDuration')

  useValidateOnChange('customEventDurationType')

  return (
    <DurationField
      fullWidth
      hideLabel
      eventType={eventType}
      isLocked={isLocked}
      isReadOnly={isReadOnly}
      useMultipleDurations={showMultipleDurations}
    />
  )
}
